import React from 'react'
import { FulfillmentTimeRow } from './FulfillmentTimeRow'

interface PickupFulfillmentTimeProps {
  className?: string
}

export const PickupFulfillmentTime: React.FC<PickupFulfillmentTimeProps> = ({
  className
}) => {
  return (
    <FulfillmentTimeRow
      className={className}
      testId='pickup-fulfillment-time-display'
      translationPrefix='pickup-fulfillment-time'
    />
  )
}

export default PickupFulfillmentTime
